<template>
  <v-container
    :class="['fill-height', 'pa-0', { primary: !$vuetify.breakpoint.lgAndDown }, 'justify-center', 'align-center']"
    fluid
  >
    <v-card
      :flat="$vuetify.breakpoint.lgAndDown"
      :style="{
        borderRadius: !$vuetify.breakpoint.lgAndDown
          ? '50px'
          : '',
        boxShadow: !$vuetify.breakpoint.lgAndDown
          ?'0px 5px 10px -2px rgba(207,50,0, .4) !important'
          : '',
        width: $vuetify.breakpoint.smAndDown ? '100%' : 'auto'
      }"
      :class="[{ 'pa-8': !$vuetify.breakpoint.lgAndDown },
        { 'my-10': !$vuetify.breakpoint.lgAndDown }]"
    >
      <v-container
        :class="!$vuetify.breakpoint.lgAndDown
        ? 'px-10'
        : $vuetify.breakpoint.smAndDown
          ? 'px-10' : 'pa-0'
      "
      >
        <v-row>
          <v-col cols="12" sm="6" md="5" :class="{ 'my-8': $vuetify.breakpoint.lgAndDown }">
            <v-container class="pa-0">
              <v-row>
                <v-col class="mb-5">
                  <BaseMyButtonDirection direction="left" :animate="true" :to="{ name: 'company' }"></BaseMyButtonDirection>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pt-0">
                  <form>
                    <v-container class="pt-0">
                      <v-row>
                        <v-col class="py-0">
                          <div class="d-flex mb-5">
                            <v-icon size="100" color="success" class="mr-2">mdi-whatsapp</v-icon>
                            <div class="d-flex flex-column justify-center">
                              <span
                                class="headline font-weight-bold grey--text"
                              >Comunicate con nosotros y te ayudaremos</span>
                              <span
                                class="display-1 font-weight-bold success--text"
                              >{{siteSettings && siteSettings.redes_sociales && siteSettings.redes_sociales.whatsapp}}</span>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <h4 class="display-2 font-weight-bold mb-5">Información del usuario</h4>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" md="6" class="pt-1">
                          <v-text-field
                            class="font-weight-bold"
                            v-model="miembro.nombres"
                            :error-messages="nombresErrors"
                            label="Nombre"
                            required
                            @input="$v.miembro.nombres.$touch()"
                            @blur="$v.miembro.nombres.$touch()"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="pt-1">
                          <v-text-field
                            class="font-weight-bold pt-4"
                            v-model="miembro.apellidos"
                            :error-messages="lastnameErrors"
                            label="Apellido"
                            required
                            @input="$v.miembro.apellidos.$touch()"
                            @blur="$v.miembro.apellidos.$touch()"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" class="pt-1">
                          <v-text-field
                            class="font-weight-bold"
                            v-model="miembro.correo"
                            :error-messages="correoErrors"
                            label="Correo"
                            required
                            @input="$v.miembro.correo.$touch()"
                            @blur="$v.miembro.correo.$touch()"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="pt-1">
                          <v-text-field
                            class="font-weight-bold"
                            v-model="miembro.password"
                            :error-messages="passwordErrors"
                            label="Contraseña"
                            type="password"
                            required
                            @input="$v.miembro.password.$touch()"
                            @blur="$v.miembro.password.$touch()"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="pt-1">
                          <v-text-field
                            class="font-weight-bold"
                            v-model="miembro.repassword"
                            :error-messages="repasswordErrors"
                            label="Repita Contraseña"
                            type="password"
                            required
                            @input="$v.miembro.repassword.$touch()"
                            @blur="$v.miembro.repassword.$touch()"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <h4
                            class="display-2 font-weight-bold mt-10 mb-4"
                          >Información de la Empresa</h4>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" class="pt-1">
                          <v-text-field
                            class="font-weight-bold"
                            v-model="miembro.nombre_empresa"
                            :error-messages="nombreEmpresaErrors"
                            label="Razon Social"
                            required
                            @input="$v.miembro.nombre_empresa.$touch()"
                            @blur="$v.miembro.nombre_empresa.$touch()"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="pt-1">
                          <v-text-field
                            class="font-weight-bold"
                            v-model="miembro.ruc"
                            :error-messages="rucErrors"
                            label="RUC"
                            required
                            @input="$v.miembro.ruc.$touch()"
                            @blur="$v.miembro.ruc.$touch()"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="pt-1">
                          <v-text-field
                            class="font-weight-bold"
                            v-model="miembro.telefono"
                            :error-messages="phoneErrors"
                            label="Telefono"
                            required
                            @input="$v.miembro.telefono.$touch()"
                            @blur="$v.miembro.telefono.$touch()"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="pt-1">
                          <v-select
                            class="font-weight-bold"
                            v-model="miembro.industria"
                            :items="industries"
                            item-text="industria"
                            :error-messages="industriaErrors"
                            menu-props="auto"
                            label="Industria"
                            required
                            @change="$v.miembro.industria.$touch()"
                            @blur="$v.miembro.industria.$touch()"
                          ></v-select>
                        </v-col>
                        <v-col cols="12" md="6" class="pt-1">
                          <v-text-field
                            class="font-weight-bold"
                            v-model="miembro.numero_empleados"
                            :error-messages="numeroEmpleados"
                            label="Numero de Empleados"
                            required
                            type="number"
                            min="0"
                            @input="$v.miembro.numero_empleados.$touch()"
                            @blur="$v.miembro.numero_empleados.$touch()"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <BaseMyButton
                            class="primary mb-1"
                            block
                            @click="register"
                            :loading="loading"
                            :disabled=" $v.$invalid || loading"
                          >REGISTRARME</BaseMyButton>
                        </v-col>
                      </v-row>
                    </v-container>
                  </form>
                  <div>
                    <span class="primary--text">
                      Tienes Cuenta?
                      <router-link
                        class="font-weight-bold"
                        :to="{ name: 'company login' }"
                      >Inicia Sesion</router-link>
                    </span>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="7"
            class="d-flex flex-column justify-center align-start pl-10"
            v-if="$vuetify.breakpoint.smAndUp"
            :style="$vuetify.breakpoint.lgAndDown ? 'position: sticky; top: 0; height:calc(100vh);' : ''"
          >
            <v-img src="@/assets/imgregistro.svg" contain></v-img>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
// @ is an alias to /src
import { validationMixin } from "vuelidate";
import {
  required,
  maxLength,
  email,
  sameAs,
  numeric
} from "vuelidate/lib/validators";

import { mapState } from "vuex";

export default {
  mixins: [validationMixin],

  validations: {
    miembro: {
      nombres: { required },
      apellidos: { required },
      correo: { required, email },
      password: { required },
      ruc: { required, numeric },
      nombre_empresa: { required },
      industria: { required },
      telefono: { required, numeric },
      numero_empleados: { required, numeric },
      repassword: {
        sameAsPassword: sameAs("password")
      }
    }
  },

  data: () => ({
    loading: false,
    show: false,
    miembro: {
      nombres: "",
      apellidos: "",
      correo: "",
      ruc: "",
      nombre_empresa: "",
      industria: "",
      numero_empleados: "",
      password: "",
      telefono: "",
      repassword: ""
    }
  }),

  created() {
    this.retrieveIndustries();
  },

  computed: {
    ...mapState(["siteSettings"]),
    ...mapState("administration/selectsData", ["industries"]),
    industriaErrors() {
      const errors = [];
      if (!this.$v.miembro.industria.$dirty) return errors;
      !this.$v.miembro.industria.required &&
        errors.push("Por favor elija una Industria");
      return errors;
    },
    nombresErrors() {
      const errors = [];
      if (!this.$v.miembro.nombres.$dirty) return errors;
      !this.$v.miembro.nombres.required &&
        errors.push("Por favor ingrese Nombre");
      return errors;
    },
    lastnameErrors() {
      const errors = [];
      if (!this.$v.miembro.apellidos.$dirty) return errors;
      !this.$v.miembro.apellidos.required &&
        errors.push("Por favor ingrese Apellido");
      return errors;
    },
    correoErrors() {
      const errors = [];
      if (!this.$v.miembro.correo.$dirty) return errors;
      !this.$v.miembro.correo.email && errors.push("Ingrese un correo válido");
      !this.$v.miembro.correo.required &&
        errors.push("Por favor ingrese Correo");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.miembro.password.$dirty) return errors;
      !this.$v.miembro.password.required &&
        errors.push("Por favor ingrese Contraseña");
      return errors;
    },
    repasswordErrors() {
      const errors = [];
      if (!this.$v.miembro.repassword.$dirty) return errors;
      !this.$v.miembro.repassword.sameAsPassword &&
        errors.push("Las contraseñas no coinciden");
      return errors;
    },
    rucErrors() {
      const errors = [];
      if (!this.$v.miembro.ruc.$dirty) return errors;
      !this.$v.miembro.ruc.required && errors.push("Por favor ingrese Ruc");
      !this.$v.miembro.ruc.numeric && errors.push("Solo ingrese números");
      return errors;
    },
    nombreEmpresaErrors() {
      const errors = [];
      if (!this.$v.miembro.nombre_empresa.$dirty) return errors;
      !this.$v.miembro.nombre_empresa.required &&
        errors.push("Por favor ingrese Razon Social");
      return errors;
    },
    phoneErrors() {
      const errors = [];
      if (!this.$v.miembro.telefono.$dirty) return errors;
      !this.$v.miembro.telefono.required &&
        errors.push("Por favor ingrese Teléfono");
      !this.$v.miembro.telefono.numeric && errors.push("Solo ingrese números");
      return errors;
    },
    numeroEmpleados() {
      const errors = [];
      if (!this.$v.miembro.numero_empleados.$dirty) return errors;
      !this.$v.miembro.numero_empleados.required &&
        errors.push("Por favor ingrese Numero de Empleados");
      !this.$v.miembro.numero_empleados.numeric &&
        errors.push("Solo ingrese números");
      return errors;
    }
  },

  methods: {
    retrieveIndustries() {
      this.$store.dispatch("administration/selectsData/retrieveIndustries");
    },
    register() {
      this.$v.$touch();
      if (this.$v.$invalid) return;
      this.loading = true;
      delete this.miembro.repassword;
      this.axios
        .post("/api/empresas/miembros/registro", this.miembro)
        .then(res => {
          this.$store.commit("SET_ALERT", {
            color: "green",
            text: "Se ha registrado correctamente",
            visible: true
          });
          this.$router.push({ name: "company login" });
        })
        .catch(err => {
          this.$store.commit("SET_ALERT", {
            color: "red",
            text: "Error al registrarse",
            visible: true
          });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
